import HeroHeader from "../../Components/hero-header-section/index.section";
import CategoriesSection from "../../Components/categories-section/index.section";
import { useState, useEffect } from "react";
import { getBanner } from "../../api-route/baner";

export default function Page() {
  const [texts, setTexts] = useState({ baner: [] })
  useEffect(() => {
    const get = async () => {
      const data = await getBanner(4)
      setTexts(data ? data : {})
    }
    get()
  }, []);

  return (
    <>
      <main className="flex flex-col">
        <HeroHeader {...texts} breadcrumb={[{ slug: 'categories', name: 'دسته بندی ها' }]} />

        <CategoriesSection head1={texts?.header3} head2={texts?.header4}/>
      </main>
    </>
  );
}
